import { MessageCircle, Mail, Phone } from "lucide-react";

// Renders one PDA USA promo as a card with: flyer · text · QR · CTAs.
// Used inside PromoSplash (modal) and on the Classes page (section).
export default function PromoCard({ promo, className = "" }) {
  return (
    <div
      data-testid={`promo-card-${promo.id}`}
      className={`bg-[#0a0a0a] border border-[#ffb700]/25 shadow-[0_0_60px_rgba(255,69,0,0.12)] overflow-hidden ${className}`}
    >
      <div className="grid grid-cols-1 lg:grid-cols-[1.4fr_1fr]">
        {/* Flyer */}
        <a
          href={promo.whatsapp}
          target="_blank"
          rel="noreferrer"
          data-testid={`promo-card-${promo.id}-flyer`}
          className="block bg-black"
        >
          <img
            src={promo.flyer}
            alt={promo.titleSuffix}
            className="w-full h-auto block"
            loading="lazy"
          />
        </a>

        {/* QR + CTAs */}
        <div className="p-6 sm:p-8 lg:p-10 flex flex-col gap-5 bg-[#0a0a0a]">
          <div>
            <p className="text-[10px] sm:text-xs uppercase tracking-[0.3em] text-[#ffb700] mb-2">
              ◆ {promo.eyebrow}
            </p>
            <h3 className="font-display text-2xl sm:text-3xl lg:text-4xl text-white leading-[1.05]">
              {promo.titlePrefix}{" "}
              <span className="phoenix-text">{promo.titleHighlight}</span>{" "}
              {promo.titleSuffix}
            </h3>
            <p className="mt-3 text-sm text-white/65 leading-relaxed whitespace-pre-line">{promo.description}</p>
          </div>

          {promo.qr && (
            <div className="bg-white p-3 sm:p-4 w-fit mx-auto sm:mx-0">
              <img
                src={promo.qr}
                alt={promo.qrAlt}
                width="220"
                height="220"
                className="w-40 h-40 sm:w-48 sm:h-48 block"
                loading="lazy"
              />
              <p className="text-[10px] uppercase tracking-[0.2em] text-black/70 text-center mt-2 font-semibold">
                Scan to register
              </p>
            </div>
          )}

          <div className="flex flex-col gap-2 sm:gap-3">
            <a
              href={promo.whatsapp}
              target="_blank"
              rel="noreferrer"
              data-testid={`promo-card-${promo.id}-whatsapp`}
              className="btn-phoenix bg-[#25D366] text-white h-12 uppercase tracking-wider text-xs font-semibold inline-flex items-center justify-center gap-2"
            >
              <MessageCircle className="w-4 h-4" /> Register on WhatsApp
            </a>
            <a
              href={promo.email}
              data-testid={`promo-card-${promo.id}-email`}
              className="border border-white/20 text-white h-12 uppercase tracking-wider text-xs font-semibold inline-flex items-center justify-center gap-2 hover:bg-[#ff4500] hover:border-[#ff4500] transition-colors"
            >
              <Mail className="w-4 h-4" /> Register via Email
            </a>
            <a
              href="tel:+19048078000"
              data-testid={`promo-card-${promo.id}-call`}
              className="border border-[#ffb700]/50 text-[#ffb700] h-12 uppercase tracking-wider text-xs font-semibold inline-flex items-center justify-center gap-2 hover:bg-[#ffb700] hover:text-black hover:border-[#ffb700] transition-colors"
            >
              <Phone className="w-4 h-4" /> Call +1 904-807-8000
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
